/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useRef, useEffect } from 'react'
import styled from 'styled-components'
import { EditorDispatch } from 'cg/components/documents/editor/slate/reducer'

function usePrevious(value) {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

const ApiTabsWrapper = ({ attributes, children, element }) => {
  const { state, dispatch } = useContext(EditorDispatch) || {}
  const { activeTabs } = state || {}
  const { defaultActiveTab, id } = element
  const previousActiveTabs = usePrevious(activeTabs)

  useEffect(() => {
    if (!previousActiveTabs && !activeTabs) {
      const initializeActiveTabs = {}
      initializeActiveTabs[id] = defaultActiveTab
      dispatch({ type: 'activateTab', payload: initializeActiveTabs })
    }
    if (activeTabs && Object.keys(activeTabs).length && !activeTabs[id]) {
      activeTabs[id] = defaultActiveTab
      dispatch({ type: 'activateTab', payload: activeTabs })
    }
  }, [previousActiveTabs, activeTabs])

  return <Tabs>{children}</Tabs>
}

export default ApiTabsWrapper

const Tabs = styled.div`
  display: block;
  margin: 0px 0px 15px;
`
